var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoUserWhiteinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.79 17.79"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.79 8.89a8.9 8.9 0 10-14.66 6.76.22.22 0 00.09.07 8.78 8.78 0 005.7 2.07 9 9 0 005.64-2 .42.42 0 00.21-.16 9 9 0 003.02-6.74zm-17 0A8.08 8.08 0 1114.7 14.5a6 6 0 00-3-4.06 3.5 3.5 0 00.74-2.18 3.54 3.54 0 10-7.07 0 3.69 3.69 0 00.74 2.18 5.92 5.92 0 00-3 4.06A7.93 7.93 0 01.82 8.89zm5.35-.61A2.73 2.73 0 118.89 11a2.73 2.73 0 01-2.72-2.72zM3.86 15.2a5.05 5.05 0 012.86-4.13 3.48 3.48 0 002.17.75 3.68 3.68 0 002.21-.77 5.2 5.2 0 012.9 4.13A8.12 8.12 0 018.92 17a8 8 0 01-5.06-1.8z",
    fill: "#fff",
    "data-name": "Capa 1"
  }))));
}

export default SvgCoUserWhiteinline;